import { ChangeDetectorRef, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Store } from '@ngrx/store';
import { lastValueFrom } from 'rxjs';
import { setViewRootFolder } from 'FoldersApp/state/view-root-folder/view-root-folder.action';
import { UNKNOWN_ERROR_MESSAGE } from 'RTQApp/features/rtq-shared/constants/constants';
import { ToastMessageType } from 'NewAngular/features/components/toast-messages/toast-messages.enum';
import { isRegistration, isSerializedSecurityObjectInfo, } from 'ClientManagementApp/ts/types/registration-item.type';
import { PageToastMessagesService } from 'NewAngular/features/components/toast-messages/page-toast-messages-service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { RTQAssessmentsFolderableCollectionService } from 'RTQApp/services/rtq-assessments-folderable-collection-ajax.service';
import { RiskToleranceQuestionnaireService } from 'RTQApp/services/rtq-service';
import * as i0 from "@angular/core";
import * as i1 from "RTQApp/services/rtq-assessments-folderable-collection-ajax.service";
import * as i2 from "RTQApp/services/rtq-service";
import * as i3 from "@ngrx/store";
import * as i4 from "NewAngular/features/components/toast-messages/page-toast-messages-service";
import * as i5 from "NewAngular/services/core/urls.service";
import * as i6 from "@angular/common";
import * as i7 from "@angular/forms";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i10 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i11 from "RTQApp/apps/rtq-assessment-list-app/components/start-rtq-modal-footer/start-rtq-modal-footer.component";
import * as i12 from "../../../../../../../../sharing/static/sharing/ts/pipes/is-shared-with-others.pipe";
const _c0 = ["basicInfoForm"];
const _c1 = a0 => ({ "is-invalid": a0 });
const _forTrack0 = ($index, $item) => $item.id;
function StartRTQAssessmentModalComponent_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "p");
    i0.ɵɵtext(2, "You already have an active Assessment for this client. You can either:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 10)(4, "div")(5, "label", 11)(6, "input", 12);
    i0.ɵɵtwoWayListener("ngModelChange", function StartRTQAssessmentModalComponent_Conditional_3_Template_input_ngModelChange_6_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.resumeExisting, $event) || (ctx_r1.resumeExisting = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "span", 13);
    i0.ɵɵelementStart(8, "span", 14);
    i0.ɵɵtext(9, "Resume existing Questionnaire");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(10, "div")(11, "label", 11)(12, "input", 12);
    i0.ɵɵtwoWayListener("ngModelChange", function StartRTQAssessmentModalComponent_Conditional_3_Template_input_ngModelChange_12_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.resumeExisting, $event) || (ctx_r1.resumeExisting = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "span", 13);
    i0.ɵɵelementStart(14, "span", 14);
    i0.ɵɵtext(15, "Start new Questionnaire");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelement(16, "div", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("value", true);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.resumeExisting);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("value", false);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.resumeExisting);
} }
function StartRTQAssessmentModalComponent_Conditional_4_For_4_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 18);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-team");
} }
function StartRTQAssessmentModalComponent_Conditional_4_For_4_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 20);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-check");
} }
function StartRTQAssessmentModalComponent_Conditional_4_For_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 17);
    i0.ɵɵlistener("click", function StartRTQAssessmentModalComponent_Conditional_4_For_4_Template_tr_click_0_listener() { const questionnaire_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.selectQuestionnaire(questionnaire_r4.id)); });
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵtext(2);
    i0.ɵɵconditionalCreate(3, StartRTQAssessmentModalComponent_Conditional_4_For_4_Conditional_3_Template, 1, 1, ":svg:svg", 18);
    i0.ɵɵpipe(4, "isSharedWithOthers");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 19);
    i0.ɵɵconditionalCreate(6, StartRTQAssessmentModalComponent_Conditional_4_For_4_Conditional_6_Template, 1, 1, ":svg:svg", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const questionnaire_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("bg-panel", ctx_r1.isQuestionnaireSelected(questionnaire_r4.id));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", questionnaire_r4.name, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpipeBind1(4, 5, questionnaire_r4) ? 3 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.isQuestionnaireSelected(questionnaire_r4.id) ? 6 : -1);
} }
function StartRTQAssessmentModalComponent_Conditional_4_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 21);
    i0.ɵɵtext(2, "No questionnaires available.");
    i0.ɵɵelementEnd()();
} }
function StartRTQAssessmentModalComponent_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "table", 15)(2, "tbody");
    i0.ɵɵrepeaterCreate(3, StartRTQAssessmentModalComponent_Conditional_4_For_4_Template, 7, 7, "tr", 16, _forTrack0);
    i0.ɵɵconditionalCreate(5, StartRTQAssessmentModalComponent_Conditional_4_Conditional_5_Template, 3, 0, "tr");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r1.questionnaires);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!(ctx_r1.questionnaires == null ? null : ctx_r1.questionnaires.length) ? 5 : -1);
} }
function StartRTQAssessmentModalComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 22)(2, "form", null, 0)(4, "div", 23)(5, "div", 24);
    i0.ɵɵtext(6, "Client Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "input", 25, 1);
    i0.ɵɵtwoWayListener("ngModelChange", function StartRTQAssessmentModalComponent_Conditional_5_Template_input_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.model.clientName, $event) || (ctx_r1.model.clientName = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 26);
    i0.ɵɵtext(10, " Please enter a name ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 23)(12, "div", 24);
    i0.ɵɵtext(13, "Assessment Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "input", 27, 2);
    i0.ɵɵtwoWayListener("ngModelChange", function StartRTQAssessmentModalComponent_Conditional_5_Template_input_ngModelChange_14_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.model.assessmentName, $event) || (ctx_r1.model.assessmentName = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 26);
    i0.ɵɵtext(17, " Please enter an assessment name ");
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const clientName_r6 = i0.ɵɵreference(8);
    const assessmentName_r7 = i0.ɵɵreference(15);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("readOnly", ctx_r1.isSubmitting || ctx_r1.linkToRegistration);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.model.clientName);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c1, (clientName_r6.touched || clientName_r6.dirty) && clientName_r6.invalid));
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("opacity", (clientName_r6.touched || clientName_r6.dirty) && clientName_r6.invalid ? "1" : "0");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("readOnly", ctx_r1.isSubmitting);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.model.assessmentName);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c1, (assessmentName_r7.touched || assessmentName_r7.dirty) && assessmentName_r7.invalid));
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("opacity", (assessmentName_r7.touched || assessmentName_r7.dirty) && assessmentName_r7.invalid ? "1" : "0");
} }
function getRegistrationSecurityItemName(registration) {
    if (isRegistration(registration)) {
        return registration.name;
    }
    if (isSerializedSecurityObjectInfo(registration)) {
        return registration.security_name;
    }
    return undefined;
}
var StartRTQModalStep;
(function (StartRTQModalStep) {
    StartRTQModalStep[StartRTQModalStep["ACTIVE_ASSESSMENT_FOUND"] = 0] = "ACTIVE_ASSESSMENT_FOUND";
    StartRTQModalStep[StartRTQModalStep["SELECT_QUESTIONNAIRE"] = 1] = "SELECT_QUESTIONNAIRE";
    StartRTQModalStep[StartRTQModalStep["BASIC_INFO"] = 2] = "BASIC_INFO";
})(StartRTQModalStep || (StartRTQModalStep = {}));
export class StartRTQAssessmentModalComponent {
    get isOnActiveAssessmentFoundStep() {
        return this.currentStep === StartRTQModalStep.ACTIVE_ASSESSMENT_FOUND;
    }
    get isOnSelectQuestionnaireStep() {
        return this.currentStep === StartRTQModalStep.SELECT_QUESTIONNAIRE;
    }
    get isOnBasicInfoStep() {
        return this.currentStep === StartRTQModalStep.BASIC_INFO;
    }
    constructor(cd, folderableCollectionService, rtqService, store, toastMessagesService, urlsService) {
        this.cd = cd;
        this.folderableCollectionService = folderableCollectionService;
        this.rtqService = rtqService;
        this.store = store;
        this.toastMessagesService = toastMessagesService;
        this.urlsService = urlsService;
        this.createdAssessment = new EventEmitter();
        this.modalOpen = false;
        this.modalHeader = 'Select Questionnaire';
        this.submitButtonText = 'Next';
        this.selectedQuestionnaireId = null;
        this.isSubmitting = false;
        this.model = {
            clientName: '',
            assessmentName: '',
        };
        this.linkToRegistration = false;
        this.asyncCreated = false;
        this.registrationId = null;
        this.currentStep = StartRTQModalStep.SELECT_QUESTIONNAIRE;
        this.activeAssessment = null;
        this.resumeExisting = false;
        this.questionnaires = [];
    }
    async openModal(registration) {
        this.resetStateForOpen();
        this.modalOpen = true;
        this.fetchQuestionnaires();
        if (!registration) {
            return;
        }
        this.registrationId = Number(registration.id);
        this.model.clientName = getRegistrationSecurityItemName(registration);
        this.linkToRegistration = true;
        this.cd.detectChanges();
        try {
            const response = await lastValueFrom(this.rtqService.checkActiveAssessmentForRegistration(this.registrationId));
            if (response.active_assessment) {
                this.activeAssessment = response.active_assessment;
                this.goToStep(StartRTQModalStep.ACTIVE_ASSESSMENT_FOUND);
                this.cd.detectChanges();
            }
        }
        catch (error) {
            this.toastMessagesService.addMessage(error?.error?.error || UNKNOWN_ERROR_MESSAGE, ToastMessageType.ERROR);
        }
    }
    closeModal() {
        this.modalOpen = false;
        this.cd.detectChanges();
    }
    // Cancel behavior: "Cancel" on Select Questionnaire step and "Back" on Basic info step
    cancel() {
        if (this.isOnBasicInfoStep) {
            this.asyncCreated = false;
            this.goToStep(StartRTQModalStep.SELECT_QUESTIONNAIRE);
            return;
        }
        this.closeModal();
    }
    // Submit behavior: "Next" on Select Questionnaire step and "Create/Copy Link" assessment on Basic info
    async submit(isAsync) {
        if (this.isOnActiveAssessmentFoundStep) {
            if (this.resumeExisting && this.activeAssessment) {
                const url = this.urlsService.getUrl(this.urlsService.RTQ.SAVED_ASSESSMENT, {
                    assessmentId: this.activeAssessment.id,
                });
                window.open(url, '_blank');
                this.closeModal();
                return;
            }
            this.goToStep(StartRTQModalStep.SELECT_QUESTIONNAIRE);
            return;
        }
        if (this.isOnSelectQuestionnaireStep) {
            this.goToStep(StartRTQModalStep.BASIC_INFO);
            return;
        }
        if (!this.selectedQuestionnaireId) {
            return;
        }
        if (this.basicInfoForm?.invalid) {
            this.basicInfoForm.form.markAllAsTouched();
            return;
        }
        if (this.isSubmitting) {
            return;
        }
        this.isSubmitting = true;
        try {
            const response = await lastValueFrom(this.rtqService.createNewAssessment(this.model.clientName.trim(), this.model.assessmentName.trim(), this.selectedQuestionnaireId, isAsync, this.folderableCollectionService.viewRootFolder?.id, this.registrationId));
            this.store.dispatch(setViewRootFolder({ id: response.parent_folder_id }));
            if (isAsync) {
                this.asyncCreated = true;
                this.cd.detectChanges();
            }
            else {
                this.closeModal();
            }
            this.createdAssessment.emit(response.assessment);
        }
        catch (error) {
            this.toastMessagesService.addMessage(error?.error?.error || UNKNOWN_ERROR_MESSAGE, ToastMessageType.ERROR);
        }
        finally {
            this.isSubmitting = false;
        }
    }
    selectQuestionnaire(questionnaireId) {
        this.selectedQuestionnaireId = questionnaireId;
    }
    isQuestionnaireSelected(questionnaireId) {
        return this.selectedQuestionnaireId === questionnaireId;
    }
    isSubmitDisabled() {
        if (this.isSubmitting || this.asyncCreated) {
            return true;
        }
        if (this.isOnActiveAssessmentFoundStep) {
            return false;
        }
        if (this.isOnSelectQuestionnaireStep) {
            return this.selectedQuestionnaireId === null;
        }
        return !!this.basicInfoForm?.invalid;
    }
    async fetchQuestionnaires() {
        try {
            this.questionnaires = await lastValueFrom(this.rtqService.getRiskToleranceQuestionnairesList());
        }
        catch (error) {
            this.toastMessagesService.addMessage(error?.error?.error || UNKNOWN_ERROR_MESSAGE, ToastMessageType.ERROR);
        }
        this.cd.detectChanges();
    }
    goToStep(step) {
        this.currentStep = step;
        if (step === StartRTQModalStep.ACTIVE_ASSESSMENT_FOUND) {
            this.modalHeader = 'Questionnaire Options';
            this.submitButtonText = 'Next';
            return;
        }
        if (step === StartRTQModalStep.SELECT_QUESTIONNAIRE) {
            this.modalHeader = 'Select Questionnaire';
            this.submitButtonText = 'Next';
            return;
        }
        this.modalHeader = 'Basic Info';
        this.submitButtonText = 'Start';
    }
    resetStateForOpen() {
        this.currentStep = StartRTQModalStep.SELECT_QUESTIONNAIRE;
        this.modalHeader = 'Select Questionnaire';
        this.submitButtonText = 'Next';
        this.isSubmitting = false;
        this.selectedQuestionnaireId = null;
        this.registrationId = null;
        this.linkToRegistration = false;
        this.asyncCreated = false;
        this.activeAssessment = null;
        this.resumeExisting = false;
        this.model = {
            clientName: '',
            assessmentName: '',
        };
    }
}
StartRTQAssessmentModalComponent.ɵfac = function StartRTQAssessmentModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StartRTQAssessmentModalComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.RTQAssessmentsFolderableCollectionService), i0.ɵɵdirectiveInject(i2.RiskToleranceQuestionnaireService), i0.ɵɵdirectiveInject(i3.Store), i0.ɵɵdirectiveInject(i4.PageToastMessagesService), i0.ɵɵdirectiveInject(i5.UrlsService)); };
StartRTQAssessmentModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StartRTQAssessmentModalComponent, selectors: [["ycn-start-rtq-assessment-modal"]], viewQuery: function StartRTQAssessmentModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.basicInfoForm = _t.first);
    } }, outputs: { createdAssessment: "createdAssessment" }, standalone: false, decls: 8, vars: 11, consts: [["basicInfoForm", "ngForm"], ["clientName", "ngModel"], ["assessmentName", "ngModel"], [3, "closeModalHandler", "extraModalClasses", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], ["id", "rtqItemTable", 1, "modal-section", 2, "max-height", "420px", "overflow-y", "auto"], [1, "divider-horizontal"], [3, "cancelHandler", "submitEvent", "asyncCreated", "submitEventLayout", "disableSubmission", "cancelButtonText", "submitButtonText"], [1, "form-row", "custom-controls-stacked"], [1, "custom-control", "custom-radio"], ["type", "radio", "name", "questionnaire-option", 1, "custom-control-input", 3, "ngModelChange", "value", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description"], [1, "table", "table-hover", "mb-1"], ["role", "button", 3, "bg-panel"], ["role", "button", 3, "click"], ["ycnIcon", "", "role", "img", 3, "name"], [1, "text-right"], ["ycnIcon", "", "role", "img", 1, "icon-check", "text-blue", "fill-current", 3, "name"], [1, "text-muted"], [1, "mb-2"], [1, "form-row"], [1, "form-label", "form-label-thin", "pb-1"], ["required", "", "type", "text", "placeholder", "ex: John Smith", "name", "clientName", 1, "form-control", 3, "ngModelChange", "readOnly", "ngModel", "ngClass"], [1, "feedback", "feedback-invalid"], ["required", "", "type", "text", "placeholder", "ex: Risk Assessment", "name", "assessmentName", 1, "form-control", 3, "ngModelChange", "readOnly", "ngModel", "ngClass"]], template: function StartRTQAssessmentModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 3);
        i0.ɵɵlistener("closeModalHandler", function StartRTQAssessmentModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 4);
        i0.ɵɵlistener("closeModalHandler", function StartRTQAssessmentModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 5);
        i0.ɵɵconditionalCreate(3, StartRTQAssessmentModalComponent_Conditional_3_Template, 17, 4, "div", 6);
        i0.ɵɵconditionalCreate(4, StartRTQAssessmentModalComponent_Conditional_4_Template, 6, 1, "div", 7);
        i0.ɵɵconditionalCreate(5, StartRTQAssessmentModalComponent_Conditional_5_Template, 18, 14, "div", 6);
        i0.ɵɵelement(6, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "ycn-start-rtq-modal-footer", 9);
        i0.ɵɵlistener("cancelHandler", function StartRTQAssessmentModalComponent_Template_ycn_start_rtq_modal_footer_cancelHandler_7_listener() { return ctx.cancel(); })("submitEvent", function StartRTQAssessmentModalComponent_Template_ycn_start_rtq_modal_footer_submitEvent_7_listener($event) { return ctx.submit($event); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-dialog")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.modalHeader);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.isOnActiveAssessmentFoundStep ? 3 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.isOnSelectQuestionnaireStep ? 4 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.isOnBasicInfoStep ? 5 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("asyncCreated", ctx.asyncCreated)("submitEventLayout", ctx.isOnBasicInfoStep)("disableSubmission", ctx.isSubmitDisabled())("cancelButtonText", ctx.isOnBasicInfoStep ? "Back" : "Cancel")("submitButtonText", ctx.isSubmitting ? "Creating\u2026" : ctx.submitButtonText);
    } }, dependencies: [i6.NgClass, i7.ɵNgNoValidate, i7.DefaultValueAccessor, i7.RadioControlValueAccessor, i7.NgControlStatus, i7.NgControlStatusGroup, i7.RequiredValidator, i7.NgModel, i7.NgForm, i8.IconDirective, i9.ModalBaseComponent, i10.SimpleModalHeaderComponent, i11.StartRTQModalFooterComponent, i12.IsSharedWithOthersPipe], encapsulation: 2 });
